import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import type { PendingChatImageAttachment } from './chatImageAttachment';
import { ChatImageLightbox } from './ChatImageLightbox';

type Props = {
  attachment: PendingChatImageAttachment;
  onRemove: () => void;
};

/**
 * 送信前の添付画像プレビュー（サムネイル + 削除ボタン）。
 * サムネイルクリックでライトボックスを開き、全体を確認できる。
 */
export function ChatImageAttachmentPreview({ attachment, onRemove }: Props) {
  const { t } = useTranslation();
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);

  return (
    <div className="group relative size-16 overflow-hidden rounded border border-gray-300 bg-white">
      <button type="button" className="block size-full" onClick={() => setIsLightboxOpen(true)}>
        <img src={attachment.previewUrl} alt={attachment.filename} className="size-full object-cover" />
      </button>
      <button
        type="button"
        aria-label={t('viewModel.aiChat.removeAttachmentLabel')}
        title={t('viewModel.aiChat.removeAttachmentLabel')}
        onClick={onRemove}
        className="absolute right-0.5 top-0.5 flex size-4 items-center justify-center rounded-full bg-black/60 text-[10px] text-white hover:bg-black/80"
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
      {isLightboxOpen && (
        <ChatImageLightbox
          src={attachment.previewUrl}
          alt={attachment.filename}
          onClose={() => setIsLightboxOpen(false)}
        />
      )}
    </div>
  );
}
